// import StakeHoldersCard from "../../ProjectPage/components/ProjectDetailsTabComponents/StakeHoldersCard";
// import ListJobsCard from "../../ProjectPage/components/ProjectDetailsTabComponents/ListJobsCard";
// import LandRights from "../../ProjectPage/components/ProjectDetailsTabComponents/LandRights";
import CoBenifitsCertificationsCard from "../../ProjectPage/components/ProjectDetailsTabComponents/CoBenifitsCertificationsCard";
import { PeopleTabMap } from "./PeopleTabMap";
import GHSAccordion from "./GHSAccordion";

const PeopleTab = () => {
  return (
    <section>
      <div className="flex items-start gap-4">
        {/* <div className="basis-1/4">
          <StakeHoldersCard />
        </div>
        <div className="flex basis-1/4 flex-col gap-4">
          <ListJobsCard />
          <LandRights />
        </div> */}
        <div className="basis-2/4">
          <GHSAccordion />
        </div>
        <div className="basis-2/4">
          <PeopleTabMap />
        </div>
      </div>
      <div className="my-4">
        <CoBenifitsCertificationsCard />
      </div>
    </section>
  );
};

export default PeopleTab;
